import React from 'react';
import PropTypes from 'prop-types';
import { P, H1 } from '../../theme/typographySitecore';
import CenteredMessage from './css';

const ErrorGeneral = ({ fields }) => (
  <>
    {fields.heading && fields.heading.value && <H1 field={fields.heading} />}
    <CenteredMessage>
      <P field={fields.errorMessage} />
    </CenteredMessage>
  </>
);

ErrorGeneral.propTypes = {
  fields: PropTypes.shape({
    heading: PropTypes.shape({
      value: PropTypes.string,
    }),
    errorMessage: PropTypes.shape({
      value: PropTypes.string,
    }),
  }),
};

export default ErrorGeneral;
